/**
 * @deprecated
 */
'use strict';

// <modal visible="true">Lorem ipsum</modal>
function dialog() {
  return {
    restrict: 'AE',
    scope: {
      visible: '='
    },
    template: `<div class="showme" ng-show="visible">
      <div class="overlay" ng-click="visible = false"></div>
      <div class="dialog">
        <div class="close" ng-click="visible = false">&times;</div>
        <div class="content" ng-transclude></div>
      </div>
    </div>`,
    replace: true,
    transclude: true,
    link: (scope, element) => {
      element.on('keyup', function (e) {
        if (e.keyCode === 27) {
          scope.$apply(function () {
            scope.visible = false;
          });
        }
      });
    }
  };
}

angular
  .module('sr.dialog', [])
  .directive('modal', dialog);
